__turbopack_context__.v({
  "artwork": "OXDMnW_artwork",
  "artworkImage": "OXDMnW_artworkImage",
  "artworkThumbnail": "OXDMnW_artworkThumbnail",
  "crdImageWrapper": "OXDMnW_crdImageWrapper",
  "credits": "OXDMnW_credits",
  "description": "OXDMnW_description",
  "descriptionTitle": "OXDMnW_descriptionTitle",
  "descriptionWrapper": "OXDMnW_descriptionWrapper",
  "errorWrapper": "OXDMnW_errorWrapper",
  "has-transcript": "OXDMnW_has-transcript",
  "inputWrapper": "OXDMnW_inputWrapper",
  "mainWrapper": "OXDMnW_mainWrapper",
  "noImageSvg": "OXDMnW_noImageSvg",
  "noTranscript": "OXDMnW_noTranscript",
  "plalistSlideTranslationsDarkMode": "OXDMnW_plalistSlideTranslationsDarkMode",
  "playerWrapper": "OXDMnW_playerWrapper",
  "playlistExhibitionSlideSubext": "OXDMnW_playlistExhibitionSlideSubext",
  "playlistShelf": "OXDMnW_playlistShelf",
  "playlistShelfTitle": "OXDMnW_playlistShelfTitle",
  "playlistSlideDescription": "OXDMnW_playlistSlideDescription",
  "playlistSlideTranslations": "OXDMnW_playlistSlideTranslations",
  "searchIcon": "OXDMnW_searchIcon",
  "searchSection": "OXDMnW_searchSection",
  "sponsorLogo": "OXDMnW_sponsorLogo",
});
